import { render, staticRenderFns } from "./HomeCurated.vue?vue&type=template&id=7d52f65c&lang=pug&"
import script from "./HomeCurated.vue?vue&type=script&lang=js&"
export * from "./HomeCurated.vue?vue&type=script&lang=js&"
import style0 from "./HomeCurated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d52f65c')) {
      api.createRecord('7d52f65c', component.options)
    } else {
      api.reload('7d52f65c', component.options)
    }
    module.hot.accept("./HomeCurated.vue?vue&type=template&id=7d52f65c&lang=pug&", function () {
      api.rerender('7d52f65c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/home/HomeCurated.vue"
export default component.exports